var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classNames from 'clsx';
import { getAriaAttributes, getDataAttributes, } from '@wix/editor-elements-common-utils';
import MeshContainer from '../../../../thunderbolt-core-components/MeshContainer/viewer/MeshContainer';
import styles from './common.scss';
import { ARIA_LABEL_DEFAULT } from './constants';
const ContainerLogicComp = (props, ref) => {
    const { id, className, meshProps, renderSlot, children, onClick, onDblClick, onFocus, onBlur, onMouseEnter, onMouseLeave, translations, hasPlatformClickHandler, a11y = {}, ariaAttributes = {}, tabIndex, role, style, } = props;
    const rootElementRef = React.useRef(null);
    const { 'aria-label-interactions': ariaLabelInteractions } = a11y, a11yAttr = __rest(a11y, ['aria-label-interactions']);
    if (ariaLabelInteractions) {
        a11yAttr['aria-label'] = (translations === null || translations === void 0 ? void 0 : translations.ariaLabel) || ARIA_LABEL_DEFAULT;
    }
    const meshContainerProps = Object.assign({ id,
        children }, meshProps);
    const containerClassName = classNames(className, {
        [styles.clickable]: hasPlatformClickHandler,
    });
    React.useImperativeHandle(ref, () => {
        return {
            focus: () => {
                var _a;
                (_a = rootElementRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            },
            blur: () => {
                var _a;
                (_a = rootElementRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            },
        };
    });
    return (React.createElement("div", Object.assign({ id: id }, getDataAttributes(props), { ref: rootElementRef, className: containerClassName, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onDoubleClick: onDblClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, style: style }, a11yAttr, getAriaAttributes(Object.assign(Object.assign({}, ariaAttributes), { tabIndex, role }))), renderSlot({
        containerChildren: React.createElement(MeshContainer, Object.assign({}, meshContainerProps)),
    })));
};
export const ContainerLogic = React.forwardRef(ContainerLogicComp);
//# sourceMappingURL=ContainerLogic.js.map